/**
 * Generated by orval 🍺
 * Do not edit manually.
 * Sara API
 * Sara AI Video Interviewer API
 * OpenAPI spec version: 1.0
 */
import {
  useQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import type {
  CandidateDetailDto,
  ListCandidatesParams,
  ListCandidatesResponseDto
} from '../model';

import { customFetch } from '../../client';


type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];



const withQueryKey = <T extends object, K>(query: T, queryKey: K): T & { queryKey: K } => {
  const result = { queryKey } as T & { queryKey: K };
  for (const key of Object.keys(query)) {
    // The explicit queryKey always wins, matching the previous
    // `{ ...query, queryKey }` spread where it was set last.
    if (key === 'queryKey') continue;
    Object.defineProperty(result, key, {
      enumerable: true,
      configurable: true,
      get: () => (query as Record<string, unknown>)[key],
    });
  }
  return result;
};

export const getListCandidatesUrl = (params: ListCandidatesParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/candidates?${stringifiedParams}` : `/candidates`
}

export const listCandidates = async (params: ListCandidatesParams, options?: Parameters<typeof customFetch>[1]): Promise<ListCandidatesResponseDto> => {

  return customFetch<ListCandidatesResponseDto>(getListCandidatesUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListCandidatesQueryKey = (params?: ListCandidatesParams,) => {
    return [
    `/candidates`, ...(params ? [params] : [])
    ] as const;
    }


export const getListCandidatesQueryOptions = <TData = Awaited<ReturnType<typeof listCandidates>>, TError = unknown>(params: ListCandidatesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listCandidates>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListCandidatesQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listCandidates>>> = ({ signal }) => listCandidates(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listCandidates>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListCandidatesQueryResult = NonNullable<Awaited<ReturnType<typeof listCandidates>>>
export type ListCandidatesQueryError = unknown


export function useListCandidates<TData = Awaited<ReturnType<typeof listCandidates>>, TError = unknown>(
 params: ListCandidatesParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof listCandidates>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listCandidates>>,
          TError,
          Awaited<ReturnType<typeof listCandidates>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListCandidates<TData = Awaited<ReturnType<typeof listCandidates>>, TError = unknown>(
 params: ListCandidatesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listCandidates>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listCandidates>>,
          TError,
          Awaited<ReturnType<typeof listCandidates>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListCandidates<TData = Awaited<ReturnType<typeof listCandidates>>, TError = unknown>(
 params: ListCandidatesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listCandidates>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useListCandidates<TData = Awaited<ReturnType<typeof listCandidates>>, TError = unknown>(
 params: ListCandidatesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listCandidates>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListCandidatesQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getGetCandidateUrl = (id: string,) => {




  return `/candidates/${id}`
}

export const getCandidate = async (id: string, options?: Parameters<typeof customFetch>[1]): Promise<CandidateDetailDto> => {

  return customFetch<CandidateDetailDto>(getGetCandidateUrl(id),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetCandidateQueryKey = (id: string,) => {
    return [
    `/candidates/${id}`
    ] as const;
    }


export const getGetCandidateQueryOptions = <TData = Awaited<ReturnType<typeof getCandidate>>, TError = unknown>(id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCandidate>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetCandidateQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getCandidate>>> = ({ signal }) => getCandidate(id, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getCandidate>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetCandidateQueryResult = NonNullable<Awaited<ReturnType<typeof getCandidate>>>
export type GetCandidateQueryError = unknown


export function useGetCandidate<TData = Awaited<ReturnType<typeof getCandidate>>, TError = unknown>(
 id: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCandidate>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getCandidate>>,
          TError,
          Awaited<ReturnType<typeof getCandidate>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetCandidate<TData = Awaited<ReturnType<typeof getCandidate>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCandidate>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getCandidate>>,
          TError,
          Awaited<ReturnType<typeof getCandidate>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetCandidate<TData = Awaited<ReturnType<typeof getCandidate>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCandidate>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetCandidate<TData = Awaited<ReturnType<typeof getCandidate>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCandidate>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetCandidateQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






